/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RegistrationTypeRequestDTO = {
    registrationType: RegistrationTypeRequestDTO.registrationType;
    userExternalId: string;
};

export namespace RegistrationTypeRequestDTO {

    export enum registrationType {
        INDIVIDUAL = 'INDIVIDUAL',
        SOLE_PROPRIETORSHIP = 'SOLE_PROPRIETORSHIP',
        LIMITED_LIABILITY = 'LIMITED_LIABILITY',
        NGO_NPO = 'NGO_NPO',
        GOVERNMENT = 'GOVERNMENT',
        PARTNERSHIP_INCORPORATED_TRUSTEES = 'PARTNERSHIP_INCORPORATED_TRUSTEES',
        CLUBS_SOCIETIES_ASSOCIATIONS = 'CLUBS_SOCIETIES_ASSOCIATIONS',
        COOPERATIVE_SOCIETIES = 'COOPERATIVE_SOCIETIES',
    }


}

